/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import React from "react";

const SingleChoice = (props:any) => {
    const {options, name, onChange, value, propClasses="", onBlur} = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
    }

    const handleOnBlur = ()=>{
        onBlur()
    }
    
    return (
        <div className={propClasses}>
            {
                options.map((o:string,i:number)=>(
                    <div role="radio" tabIndex={0}  className="choice-label-wrap" key={i}>
                        <div className={`choice-label`}><label className={`choice-label`}>
                            <input  id={`${name}-${i}`} onBlur={handleOnBlur} type="radio" checked={o==value} onChange={handleChange} value={o} name={name}/> 
                            <span>{o}</span> 
                        </label> </div>
                      
                    </div>
                ))
            }          
        </div>
    )
}

export default SingleChoice;